import { render, staticRenderFns } from "./NavLayerMobile.vue?vue&type=template&id=4824b590&"
import script from "./NavLayerMobile.vue?vue&type=script&lang=js&"
export * from "./NavLayerMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4824b590')) {
      api.createRecord('4824b590', component.options)
    } else {
      api.reload('4824b590', component.options)
    }
    module.hot.accept("./NavLayerMobile.vue?vue&type=template&id=4824b590&", function () {
      api.rerender('4824b590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mobileview/NavLayerMobile.vue"
export default component.exports